"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeCalendar = RangeCalendar;
var _calendar = require("@react-aria/calendar");
var _calendar2 = require("@react-stately/calendar");
var _date = require("@internationalized/date");
var _CalendarGrid = require("./CalendarGrid");
var _react = _interopRequireDefault(require("react"));
var _FlexRow = require("../../../layout/flex/FlexRow");
var _FlexColumn = require("../../../layout/flex/FlexColumn");
var _CalendarHeader = require("./CalendarHeader");
var _Calendar = require("./Calendar.styled");
var _hooks = require("./hooks");
var _reactAria = require("react-aria");
var _jsxRuntime = require("react/jsx-runtime");
function RangeCalendar(props) {
  var _ref = (0, _reactAria.useLocale)(),
    locale = _ref.locale;
  var highlightToday = props.highlightToday,
    minValue = props.minValue,
    disablePastDates = props.disablePastDates,
    defaultValue = props.defaultValue;
  var rangeCalendarConfig = _objectSpread({}, props, {
    minValue: minValue ? minValue : disablePastDates ? (0, _date.today)((0, _date.getLocalTimeZone)()) : undefined,
    defaultValue: defaultValue || {
      start: (0, _date.today)((0, _date.getLocalTimeZone)()).add({
        weeks: 1
      }),
      end: (0, _date.today)((0, _date.getLocalTimeZone)()).add({
        weeks: 2
      })
    },
    visibleDuration: {
      months: 2
    },
    locale: locale,
    createCalendar: _date.createCalendar
  });
  var state = (0, _calendar2.useRangeCalendarState)(rangeCalendarConfig);
  var ref = _react.default.useRef(null);
  var _ref2 = (0, _calendar.useRangeCalendar)(props, state, ref),
    calendarProps = _ref2.calendarProps,
    prevButtonProps = _ref2.prevButtonProps,
    nextButtonProps = _ref2.nextButtonProps;
  var _ref3 = (0, _hooks.useYearButtonProps)(state),
    prevYearButtonProps = _ref3.prevYearButtonProps,
    nextYearButtonProps = _ref3.nextYearButtonProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({}, calendarProps, {
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
      gap: 'none',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexColumn.FlexColumn, {
        alignSelf: 'start',
        flex: '0 0 auto',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CalendarHeader.CalendarHeader, {
          showBackButtons: true,
          timezone: state.timeZone,
          dateInMonth: state.visibleRange.start.toDate(state.timeZone),
          prevButtonProps: prevButtonProps,
          prevYearButtonProps: prevYearButtonProps
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CalendarGrid.CalendarGrid, {
          state: state,
          highlightToday: highlightToday
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.MonthSeparator, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexColumn.FlexColumn, {
        alignSelf: 'start',
        flex: '0 0 auto',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CalendarHeader.CalendarHeader, {
          showForwardButtons: true,
          timezone: state.timeZone,
          dateInMonth: state.visibleRange.end.toDate(state.timeZone),
          nextButtonProps: nextButtonProps,
          nextYearButtonProps: nextYearButtonProps
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CalendarGrid.CalendarGrid, {
          state: state,
          offset: {
            months: 1
          }
        })]
      })]
    })
  }));
}